import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";

import App from "./App";
import { UserProvider } from "./contexts/user.context";
import { CategoriesProvider } from "./contexts/categories.context";
import { CartProvider } from "./contexts/cart.context";

import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "./utils/stripe/stripe.utils";

import "./index.scss";

const client = new ApolloClient({
	uri: "https://crwn-clothing.com/",
	cache: new InMemoryCache(),
});

const rootElement = document.getElementById("root");

render(
	<React.StrictMode>
		<ApolloProvider client={client}>
			<BrowserRouter>
				<UserProvider>
					<CategoriesProvider>
						<CartProvider>
							<Elements stripe={stripePromise}>
								<App />
							</Elements>
						</CartProvider>
					</CategoriesProvider>
				</UserProvider>
			</BrowserRouter>
		</ApolloProvider>
	</React.StrictMode>,
	rootElement
);
